<p class="font-s color-font-secondary mt-5">
  AI is in beta, free of charge, but may give inaccurate responses.
</p>
